import { TrlPillClean } from './TrlPillClean';

export { TrlPillClean } from './TrlPillClean';
export default TrlPillClean;
